"use client"

import { Wheat } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WheatIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WheatIcon = component(Icon)({ as: Wheat })
